import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-labelledby", "aria-label"]
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_4 = ["id"]
const _hoisted_5 = {
  key: 1,
  class: "modal-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.opened)
    ? (_openBlock(), _createElementBlock("div", {
        class: "modal-consulte-bg",
        key: _ctx.refreshCounter,
        style: _normalizeStyle({ zIndex: _ctx.zIndex })
      }, [
        (_ctx.opened)
          ? (_openBlock(), _createElementBlock("div", {
              ref: "dialogRef",
              class: "modal fade show",
              tabindex: "-1",
              role: "dialog",
              key: _ctx.refreshCounter,
              "aria-labelledby": _ctx.hideHeader ? undefined : _ctx.idTitulo,
              "aria-label": _ctx.hideHeader ? _ctx.tituloAcessivel : undefined,
              "aria-modal": "true",
              style: {"display":"unset","border-radius":"var(--ct-modal-inner-border-radius)"},
              onKeydown: [
                _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"])),
                _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.manterFocoDentro && _ctx.manterFocoDentro(...args)))
              ]
            }, [
              _createElementVNode("div", {
                class: "modal-dialog modal-dialog-centered",
                style: _normalizeStyle({ width: _ctx.modalWidth })
              }, [
                _createElementVNode("div", _hoisted_2, [
                  (!_ctx.hideHeader)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", {
                          id: _ctx.idTitulo,
                          class: "modal-consulte-titulo"
                        }, [
                          _renderSlot(_ctx.$slots, "header", {}, () => [
                            _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "modal-title" }, "Titulo do modal", -1))
                          ])
                        ], 8, _hoisted_4),
                        (!_ctx.hideHeader)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn-close",
                              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
                              "aria-label": "Fechar",
                              title: "Fechar"
                            }))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: "modal-body",
                    style: _normalizeStyle({ maxHeight: _ctx.alturaMaximaCorpo })
                  }, [
                    _renderSlot(_ctx.$slots, "content")
                  ], 4),
                  (!_ctx.hideFooter)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _renderSlot(_ctx.$slots, "actions", {}, () => [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-light",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                          }, "Fechar")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 4)
            ], 40, _hoisted_1))
          : _createCommentVNode("", true)
      ], 4))
    : _createCommentVNode("", true)
}